export const decoder = (urlString: string) => {
  // Ignore empty strings
  if (urlString.length === 0) {
    return;
  }

  // Convert numbers
  if (/^(\d+|\d*\.\d+)$/.test(urlString)) {
    return parseFloat(urlString);
  }

  // Convert dates
  const decodedStr = decodeURIComponent(urlString);
  if (/^.*T.*:.*:.*Z$/.test(decodedStr)) {
    return new Date(decodedStr);
  }

  // Convert keywords to types
  const keywords: any = {
    true: true,
    false: false,
    null: null,
    undefined: undefined,
  };

  if (urlString in keywords) {
    return keywords[urlString];
  }

  // Normal string
  return decodeURIComponent(urlString);
};
